import { ReactNode } from "react";
import dynamic from "next/dynamic";
import { GlobalContextProvider } from "contexts/globalContext";
import { LocalizationContextProvider } from "contexts/localizationContext";
import { DrupalProvider } from "contexts/drupalContext";

const AdminTools = dynamic(() => import("../components/AdminTools"), {
	ssr: false,
});

const LayoutDefault = dynamic(() => import("./Default"), { ssr: false });

interface iLayout {
	pageProps: any;
	children: ReactNode;
}

const Layout = (props: iLayout) => {
	const { children, pageProps } = props;

	const revisionStatus = {
		state: pageProps?.data?.state || null,
		published: pageProps?.data?.published || null,
		isCurrentRevision: pageProps?.data?.isCurrentRevision || null,
	};

	if (typeof window === "undefined") {
		return <></>;
	} else {
		return (
			<GlobalContextProvider ssrData={pageProps}>
				<LocalizationContextProvider locale={pageProps?.language || "en"} tld={pageProps?.tld || "com"}>
					<DrupalProvider locale={pageProps?.language || "en"} tld={pageProps?.tld || "com"}>
						<LayoutDefault pageProps={pageProps || {}}>
							{children}
							<AdminTools
								uuid={pageProps?.data?.uuid}
								nid={pageProps?.data?.nid}
								langCode={pageProps?.language || "en"}
								status={revisionStatus}
							/>
						</LayoutDefault>
					</DrupalProvider>
				</LocalizationContextProvider>
			</GlobalContextProvider>
		);
	}
};

export default Layout;
